<input
  *ngIf="id; else noId"
  [id]="id"
  [name]="name"
  class="base-input"
  [type]="type"
  [placeholder]="placeholder"
  [value]="value"
  (input)="onInput($event)"
  (focus)="handleFocus($event)"
  (blur)="handleBlur($event)"
  (keypress)="handleKeyPress($event)"
  [autocomplete]="autocomplete"
  [attr.aria-label]="ariaLabel"
  [attr.maxlength]="maxlength"
  [disabled]="disabled"
  [ngClass]="{ fluid: isFluid }"
  [ngStyle]="{ 'margin-bottom': mb, 'margin-top': mt }"
/>

<ng-template #noId>
  <input
    [name]="name"
    class="base-input"
    [type]="type"
    [placeholder]="placeholder"
    [value]="value"
    (input)="onInput($event)"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
    (keypress)="handleKeyPress($event)"
    [autocomplete]="autocomplete"
    [attr.aria-label]="ariaLabel"
    [attr.maxlength]="maxlength"
    [disabled]="disabled"
    [ngClass]="{ fluid: isFluid }"
    [ngStyle]="{ 'margin-bottom': mb, 'margin-top': mt }"
/>
</ng-template>
